import React from "react";

interface MessageIconProps {
  fill?: string;
  onClick?: () => void;
  width?: string;
  height?: string;
}

const ServiceRequestsIcon: React.FC<MessageIconProps> = (props) => {
  return (
    <svg
      className="svg-icon"
      style={{
        width: props.width ?? "1em",
        height: props.height ?? "1em",
        verticalAlign: "middle",
        overflow: "hidden",
      }}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
    >
      <path
        d="M37.11,29.55l7.75,7.75,1.45-1.45L38.55,28.1c-.3-.3,0-1.35,0-1.35L33.3,22.23l-2.08,2.08,4.53,5.24S36.85,29.3,37.11,29.55Z"
        fill={props.fill || "currentColor"}
      />
      <path
        d="M56,41.89,50.89,47,62,58.09a2.3,2.3,0,0,0,3.26,0l1.81-1.81a2.3,2.3,0,0,0,0-3.26Z"
        fill={props.fill || "currentColor"}
      />
      <path
        d="M63.18,31.22a3.11,3.11,0,1,1-4.4-4.4L63.65,22a8.56,8.56,0,0,0-3.45-.79,8.71,8.71,0,0,0-8.64,8.64,8.56,8.56,0,0,0,.79,3.45L32.11,53.5a3.11,3.11,0,1,0,4.4,4.4L56.74,37.65a8.56,8.56,0,0,0,3.45.79,8.71,8.71,0,0,0,8.64-8.64A8.56,8.56,0,0,0,68,26.35Z"
        fill={props.fill || "currentColor"}
      />
      <path
        d="M77,11.24H23a12,12,0,0,0-12,12v36a12,12,0,0,0,12,12H42.18l16.74,16.5a3.42,3.42,0,0,0,2.39,1,2.82,2.82,0,0,0,1.33-.33A2.58,2.58,0,0,0,64,85.77l-.38-14.52H77a12,12,0,0,0,12-12v-36A12,12,0,0,0,77,11.24Zm8,48a8,8,0,0,1-8,8H61.54a2,2,0,0,0-2,2.05l.36,13.79L44.4,67.82a2,2,0,0,0-1.4-.58H23a8,8,0,0,1-8-8v-36a8,8,0,0,1,8-8H77a8,8,0,0,1,8,8Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default ServiceRequestsIcon;
